export class UserAccess {
  constructor(
    public email: string,
    public access: 'owner' | 'editor' | 'readOnly',
    public name?: string
  ) {}
}
